import { Navigate, Outlet } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import { useAuth } from '@/hooks/useAuth';
import { useOrgStore } from '@/stores/orgStore';

interface ProtectedRouteProps {
  requireRole?: 'admin' | 'manager' | 'member';
  requireOrganization?: boolean;
}

export function ProtectedRoute({ requireRole: _requireRole, requireOrganization = false }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, isInitialized } = useAuth();
  const { currentOrg, isLoading: orgLoading } = useOrgStore();

  // Show loader while checking auth status
  if (!isInitialized || isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Show loader while loading organization
  if (requireOrganization && orgLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  // Redirect to get-started if user has no organization
  if (requireOrganization && !currentOrg) {
    return <Navigate to="/get-started" replace />;
  }

  // TODO: Add role-based access control when needed

  return <Outlet />;
}
